import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Entity } from 'src/app/models/fund-details.model'
import { SortByPipe } from 'src/app/utils/pipes/sort-by.pipe'

const CARET_UP_SMALL='caret-up-small'

@Component({
  selector: 'VFA-sort-by',
  templateUrl: './sort-by.component.html',
  styleUrls: ['./sort-by.component.scss'],
})
export class SortByComponent {
  @Input() pageNumber: number
  @Input() fullData: Entity[]
  @Input() initialColumn: string
  @Input() sortColumn: string
  @Input() sortDirection: string
  @Input() switchModel?: boolean

  @Output() public changeTabData: EventEmitter<any> = new EventEmitter<any>()
  arrowDirection = CARET_UP_SMALL
  label = 'Sort Ascending'
  type: string

  constructor(private readonly sortByPipe: SortByPipe) {}
  // eslint-disable-next-line complexity
  sortBy() {
    if (
      this.sortDirection === 'asc' &&
      this.sortColumn !== this.initialColumn
    ) {
      this.sortColumn = this.initialColumn
    } else if (this.sortDirection === 'asc') {
      this.sortDirection = 'desc'
      this.arrowDirection = 'caret-down-small'
      this.label = 'Sort Descending'
      this.sortColumn = this.initialColumn
    } else if (
      this.sortDirection === 'desc' &&
      this.sortColumn !== this.initialColumn
    ) {
      this.sortColumn = this.initialColumn
    } else if (this.sortDirection === 'desc') {
      this.sortDirection = 'asc'
      this.arrowDirection = CARET_UP_SMALL
      this.label = 'Sort Ascending'
      this.sortColumn = this.initialColumn
    }
    if (this.switchModel === null) {
      this.switchModel = false
    }

    this.fullData = this.sortByPipe.transform(
      this.fullData,
      this.sortColumn,
      this.sortDirection,
      this.switchModel,
    )
    this.changeTabData.emit({
      fullData: this.fullData,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection,
      switchModel: this.switchModel,
    })
  }
  ngOnChanges(): void {
    if (this.sortDirection === 'asc') {
      this.arrowDirection = 'caret-down-small'
    } else if (this.sortDirection === 'desc') {
      this.arrowDirection = CARET_UP_SMALL
    }
  }
}
